import CommonColorMapping from "./CommonColorMapping";
import PitchPlayerColors from '@/enums/PitchColors';

/** @type {ColorMap} */
export const BaseballPitchTypeSeriesColorMapping = {
  ...PitchPlayerColors,
  ...CommonColorMapping,
};
